import { cloneDeep, remove } from "lodash";

const initialState = {
  roles: [],
  totalPages: 0
};

const rolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_STAFF':
      return {
        ...state,
        staff: action.data.staff,
        totalPages: action.data.total_pages
      };
    default:
      return state;
  }
};

export default rolesReducer;
